import React, { useEffect, useState } from 'react'
import { GetActualiteById } from './Admin/Main/services';
import './styles.css'

export default function Actuality() {

  const [data, setData] = useState(null)

  useEffect(() => {
    const queryString = window.location.href;
    var id = queryString.match(/\/(\d+)$/)[1];

    GetActualiteById(id).then(source => setData(source))
  }, [])

  return (
    <div>
      <ActualityCard data={data} />
    </div>
  )
}

const ActualityCard = ({ data }) => {
  return (
    data ?
      <div className='actuality-container'>
        <a className='come-back' href="/">Revenir a l'accueil</a>
        <h3 className='actuality-subtitle'>{data.title}</h3>

        <div className="landing_api-card-wrapper-white">
          <span>{data.posteddate}</span>

          <div className='actuality-img'>
            <img className='actuality-preview' src={`https://dkbsign.com/dkbsign_web_api/public/storage/actualities/${data.img}`} alt="actuality-img" />
          </div>

          <div className="card-one-paragraph actuality-txt">
            {data.content}
          </div>
        </div>
      </div>
      :
      <div className='not-actuality'>Aucune actualite</div>
  )
}